import script from "./EventInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EventInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./EventInfoModal.vue?vue&type=style&index=0&id=b2824588&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2824588"]])

export default __exports__